import AboutHero from "../../components/AboutHero/AboutHero";
import AboutTimeline from "../../components/AboutTimeline/AboutTimeline";
import styles from "./About.module.css";

const About = () => {
  return (
    <div className={styles.aboutPage}>
      <AboutHero />
      <AboutTimeline />
    </div>
  );
};

export default About;